import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import CmsContactDetails from "./CmsContactDetails";
import CmsFooterIcons from "./CmsFooterIcons";
import Reviews from "./Reviews";
import QuestionList from "./Questions/List/QuestionList";
import AuthWrapper from "../../../utils/AuthWrapper";
import TabPanel from "./CreateTabPanel";

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));


const tabsNames = [
  {
    tabName: "REVIEW",
    tabId: "REVIEW_QUESTIONS_REVIEW",
  },
  {
    tabName: "QUESTIONS",
    tabId: "REVIEW_QUESTIONS_QUESTIONS",
  },
];


export default function ReviewAndQuestion() {
  let tabsToShow = tabsNames?.filter((e, i) => {
    return AuthWrapper({ type: "TAB", name: e?.tabId, inBoolean : true});
  });
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const getTabPanel = (ele) => {
    let moduleToShow;
    switch (ele) {
      case "REVIEW":
        moduleToShow = <Reviews />;
        break;
      case "QUESTIONS":
        moduleToShow = <QuestionList />;
        break;
      default:
        break;
    }
    return moduleToShow;
  };
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
        >
          {tabsToShow.map((ele, ind) => {
            return (
              <Tab
                style={{ textTransform: "capitalize" }}
                label={ele?.tabName}
                {...a11yProps(ind)}
              />
            );
          })}
        </Tabs>
      </AppBar>

      {tabsToShow.map((ele, ind) => {
        return (
          <TabPanel value={value} index={ind}>
            {getTabPanel(ele?.tabName)}
          </TabPanel>
        );
      })}
    </div>
  );
}
